module.exports = __webpack_public_path__ + "static/img/1101.fa99c3c.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/qingye/1101.png
// module id = juQw
// module chunks = 1